import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const website = {
    "id": "f3D3Q7",
    "name": "Website Development",
    "img": "/app/static/templates/software/website.jpg",
    "description": "Some long description here to show purpose of this template",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};

const userStoryMapping = {
    "id": "pKvr4v",
    "name": "User Story Mapping",
    "img": "/app/static/templates/product/user-story.jpg",
    "description": "Record and assign user stories to sprints with this template.",
    systemType: ProjectSystemType.BACKLOG,
    copyToLocalTemplate: false,
    setupDemoProject: 'IT',
    demoFolderColor: 20
};

const productRoadmap = {
    "id": "c03n1i",
    "name": "Product Roadmap",
    "img": "/app/static/templates/product/roadmap.jpg",
    "description": "Quarterly product planning template with timeline.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};

const organizationalChart = {
    "id": "URjNeV",
    "name": "Organizational Chart",
    "img": "/app/static/templates/hr/org-chart.jpg",
    "description": "An organized table view of the reporting structure and staff details.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'HR',
    demoFolderColor: 20
};

const contractorManagement = {
    "id": "EMs04U",
    "name": "Contractor Management",
    "img": "/app/static/templates/hr/contractors.jpg",
    "description": "Template to record key contractor information and contract details.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'HR',
    demoFolderColor: 20
};

const jobRecruitment = {
    "id": "tnccVu",
    "name": "Job Recruitment",
    "img": "/app/static/templates/hr/recruitment.jpg",
    "description": "Structure and workflow to manage recruitment for any role.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'HR',
    demoFolderColor: 20
};

const featureRequests = {
    "id": "zLwi8t",
    "name": "Feature Requests",
    "img": "/app/static/templates/product/feature-requests.jpg",
    "description": "Convenient feature request tracker to prioritize and execute.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Product Management',
    demoFolderColor: 20
};

const marketingPlan = {
    "id": "BBaVPK",
    "name": "Marketing Plan",
    "img": "/app/static/templates/marketing/plan.jpg",
    "description": "Some long description here to show purpose of this template",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
    demoFolderColor: 20
};


export default {
    id: 'startup',
    name: "Startup",
    items: [

        productRoadmap,

        website,


        userStoryMapping,

        featureRequests,

        organizationalChart,

        contractorManagement,

        jobRecruitment,


        marketingPlan

    ]
};